import { Link } from "react-router-dom";

export default function Banner({ className }) {
  return (
    <>
      <div className={`w-full ${className || ""}`}>
        <div className="container-x mx-auto">
          <div className="main-wrapper w-full">
            <div className="banner-card xl:flex xl:space-x-[30px] xl:h-[600px]  mb-[30px]">
              <div data-aos="fade-right" className="xl:w-[740px] w-full h-full">
                <Link to="/category/5">
                  <picture>
                    <source
                      media="(min-width:1025px)"
                      srcSet={`${process.env.PUBLIC_URL}/assets/images/banner-1.png`}
                    />
                    <img
                      src={`${process.env.PUBLIC_URL}/assets/images/banner-1.png`}
                      alt=""
                      className="w-full max-w-full h-auto object-cover"
                    />
                  </picture>
                </Link>
              </div>
              <div
                data-aos="fade-left"
                className="flex-1 flex xl:flex-col flex-row  xl:space-y-[30px] h-full"
              >
                <div className="w-full xl:h-1/2">
                  <Link to="/category/2">
                    <img
                      src={`${process.env.PUBLIC_URL}/assets/images/banner-2.png`}
                      alt=""
                      className="w-full h-full"
                    />
                  </Link>
                </div>
                <div className="w-full xl:h-1/2">
                  <Link to="/category/2">
                    <img
                      src={`${process.env.PUBLIC_URL}/assets/images/banner-3.png`}
                      alt=""
                      className="w-full h-full"
                    />
                  </Link>
                </div>
              </div>
            </div>
            <div
              data-aos="fade-up"
              className="best-services w-full bg-white flex flex-col space-y-10 lg:space-y-0 lg:flex-row lg:justify-between lg:items-center lg:h-[110px] px-10 lg:py-0 py-10"
            >
              <div className="item">
                <div className="flex space-x-5 items-center">
                  <div>
                    <img
                      src={`${process.env.PUBLIC_URL}/assets/images/icons/shipping.png`}
                      className="w-[44px] h-[44px]"
                      alt="Free shipping"
                    />
                  </div>
                  <div>
                    <p className="text-black text-[15px] font-700 tracking-wide mb-1">
                      Free Shipping
                    </p>
                    <p className="text-sm text-qgray">
                      When ordering over Rs 5500
                    </p>
                  </div>
                </div>
              </div>
              <div className="item">
                <div className="flex space-x-5 items-center">
                  <div>
                    <img
                      src={`${process.env.PUBLIC_URL}/assets/images/icons/return.png`}
                      className="w-[44px] h-[44px]"
                      alt="Free Return"
                    />
                  </div>
                  <div>
                    <p className="text-black text-[15px] font-700 tracking-wide mb-1">
                      Free Return
                    </p>
                    <p className="text-sm text-qgray">
                      Hassel Free Returns within 7 days
                    </p>
                  </div>
                </div>
              </div>
              <div className="item">
                <div className="flex space-x-5 items-center">
                  <div>
                    <img
                      src={`${process.env.PUBLIC_URL}/assets/images/icons/payment.png`}
                      className="w-[44px] h-[44px]"
                      alt="Secure Payment"
                    />
                  </div>
                  <div>
                    <p className="text-black text-[15px] font-700 tracking-wide mb-1">
                      Secure Payment
                    </p>
                    <p className="text-sm text-qgray">
                      100% Secure Online Payment
                    </p>
                  </div>
                </div>
              </div>
              <div className="item">
                <div className="flex space-x-5 items-center">
                  <div>
                    <img
                      src={`${process.env.PUBLIC_URL}/assets/images/icons/quality.png`}
                      className="w-[44px] h-[44px]"
                      alt="Best Quality"
                    />
                  </div>
                  <div>
                    <p className="text-black text-[15px] font-700 tracking-wide mb-1">
                      Best Quality
                    </p>
                    <p className="text-sm text-qgray">
                      Original Product Guarenteed
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
